// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__3Wgtw","description":"style_description__3n5Gt","footer":"style_footer__4Cczb","aboutBox":"style_aboutBox__1DLmx","teacherName":"style_teacherName__y7fJS"};